import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { getProductCollectionById } from '../../api/productCollectionApi'
import { pageModel } from '../../utils/model'
import { PRODUCT_PATH, getPageProducts } from '../../api/productApi'
import { useDispatch, useSelector } from 'react-redux'
import Input from '../../components/Input'
import { setProductSearchParamsAction } from '../../redux/feature/searchParamsSlice'
import { FaEye } from 'react-icons/fa'
import { translateProductType } from '../../utils/translator'
import { useApiProgress } from '../../hooks/ApiProgress'
import { COLOR_PATH, getPageColors } from '../../api/colorApi'
import { PATTERN_PATH, getPagePatterns } from '../../api/patternApi'
import { WEIGHT_PATH, getPageWeights } from '../../api/weightApi'
import useFirstRender from '../../hooks/FirstRender'
import ColorPicker from '../../components/color/ColorPicker'
import WeightPicker from '../../components/weight/WeightPicker'
import PatternPicker from '../../components/pattern/PatternPicker'
import LoadMore from '../../components/common/LoadMore';
import { formatNumber } from '../../utils/functions'

const VariationListPage = ({ title }) => {

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const isFirstRender = useFirstRender()
    const { id } = useParams()

    const [collection, setCollection] = useState()
    const [productPage, setProductPage] = useState(pageModel)
    const searchParams = useSelector(state => state.searchParams.product)
    const pendingApiCall = useApiProgress('get', `${PRODUCT_PATH}/page`, false)
    const dispatch = useDispatch()

    const variationFilters = () => ({ ...searchParams, collectionId: id, colorId: searchParams.color?.id, weightId: searchParams.weight?.id, patternId: searchParams.pattern?.id })
    const nav = useNavigate()

    useEffect(() => {
        getProductCollectionById(id)
            .then(res => {
                setCollection(res.data)
            })
        getPageProducts({ ...variationFilters(), page: 0 })
            .then(res => {
                setProductPage(res.data)
            })
    }, [id])

    const [colorPage, setColorPage] = useState({
        content: []
    })

    const [patternPage, setPatternPage] = useState({
        content: []
    })

    const [weightPage, setWeightPage] = useState({
        content: []
    })

    const pendingApiCallColor = useApiProgress('get', `${COLOR_PATH}/page`, false)
    const pendingApiCallPattern = useApiProgress('get', `${PATTERN_PATH}/page`, false)
    const pendingApiCallWeight = useApiProgress('get', `${WEIGHT_PATH}/page`, false)

    const [colorQuery, setColorQuery] = useState('')
    const [patternQuery, setPatternQuery] = useState('')
    const [weightQuery, setWeightQuery] = useState('')

    const [searchTimerColor, setSearchTimerColor] = useState();
    const [searchTimerPattern, setSearchTimerPattern] = useState();
    const [searchTimerWeight, setSearchTimerWeight] = useState();

    const onLoadMore = () => {
        if (!productPage.last) {
            loadProducts({ ...variationFilters(), lastId: productPage.content[productPage.content.length - 1]?.id })
        }
    }

    const loadProducts = (params) => {
        !pendingApiCall &&
            getPageProducts(params)
                .then(res => {
                    setProductPage(prevState => ({ ...res.data, content: [...prevState.content, ...res.data.content] }))
                })
    }

    const searchingColor = async (params) => {
        if (searchTimerColor) clearTimeout(searchTimerColor);
        let timer = setTimeout(() => {
            getPageColors(params)
                .then(res => {
                    setColorPage(res.data)
                })
        }, 500);
        setSearchTimerColor(timer);
    }

    const searchingPattern = async (params) => {
        if (searchTimerPattern) clearTimeout(searchTimerPattern);
        let timer = setTimeout(() => {
            getPagePatterns(params)
                .then(res => {
                    setPatternPage(res.data)
                })
        }, 500);
        setSearchTimerPattern(timer);
    }

    const searchingWeight = async (params) => {
        if (searchTimerWeight) clearTimeout(searchTimerWeight);
        let timer = setTimeout(() => {
            getPageWeights(params)
                .then(res => {
                    setWeightPage(res.data)
                })
        }, 500);
        setSearchTimerWeight(timer);
    }

    const onClickLoadMoreColor = () => {
        if (!colorPage.last) {
            loadColors({ search: colorQuery, lastId: colorPage.content[colorPage.content.length - 1]?.id })
        }
    }

    const onClickLoadMorePattern = () => {
        if (!patternPage.last) {
            loadPatterns({ search: patternQuery, lastId: patternPage.content[patternPage.content.length - 1]?.id })
        }
    }

    const onClickLoadMoreWeight = () => {
        if (!weightPage.last) {
            loadWeights({ search: weightQuery, lastId: weightPage.content[weightPage.content.length - 1]?.id })
        }
    }

    const loadColors = (params) => {
        !pendingApiCallColor &&
            getPageColors(params)
                .then(res => {
                    setColorPage(prevState => ({ ...res.data, content: prevState.content.concat(res.data.content) }))
                })
    }

    const loadPatterns = (params) => {
        !pendingApiCallPattern &&
            getPagePatterns(params)
                .then(res => {
                    setPatternPage(prevState => ({ ...res.data, content: prevState.content.concat(res.data.content) }))
                })
    }

    const loadWeights = (params) => {
        !pendingApiCallWeight &&
            getPageWeights(params)
                .then(res => {
                    setWeightPage(prevState => ({ ...res.data, content: prevState.content.concat(res.data.content) }))
                })
    }

    useEffect(() => {
        !isFirstRender && searchingColor({ search: colorQuery })
    }, [colorQuery])

    useEffect(() => {
        !isFirstRender && searchingPattern({ search: patternQuery })
    }, [patternQuery])

    useEffect(() => {
        !isFirstRender && searchingWeight({ search: weightQuery })
    }, [weightQuery])

    const [searchTimer, setSearchTimer] = useState();

    useEffect(() => {
        loadColors({ size: 20 })
        loadPatterns({ size: 20 })
        loadWeights({ size: 20 })
    }, [])

    const searching = async (params) => {
        if (searchTimer) clearTimeout(searchTimer);
        let timer = setTimeout(() => {
            getPageProducts(params)
                .then(res => {
                    setProductPage(res.data)
                })
        }, 500);
        setSearchTimer(timer);
    }

    useEffect(() => {
        !isFirstRender && searching({ ...variationFilters(), page: 0 })
    }, [searchParams])

    return (
        <div>
            <div className='mb-1 border-b border-zinc-300 mb-3'>
                <label className='text-2xl'>
                    VARYASYONLAR
                </label>
            </div>
            <div className='mb-3'>
                <label className='block'>Ürün Kodu : {collection?.code} </label>
                <label className='block'>Ürün Adı : {collection?.name} </label>
            </div>
            <table className='w-full text-left text-zinc-900 mb-10 text-sm'>
                <thead className='text-xs uppercase tracking-wide sticky top-0 bg-zinc-50'>
                    <tr>
                        <th className='p-2 w-1/12'>Id</th>
                        <th className='p-2 w-2/12'>Varyasyon Adı</th>
                        <th className='p-2 w-2/12'>Renk</th>
                        <th className='p-2 w-2/12'>Gramaj</th>
                        <th className='p-2 w-2/12'>Desen</th>
                        <th className='p-2 w-1/12'>Ürün Tipi</th>
                        <th className='p-2 w-2/12'>Stok (metre)</th>
                        {/* <th className='p-2 w-1/12'>Ort. Maliyet (USD/m)</th> */}
                        {/* <th className='p-2 w-1/12'>Aksiyon</th> */}
                    </tr>
                </thead>
                <tbody>
                    <tr className='border-b items-center sticky top-8 bg-zinc-50'>
                        <td className='px-2'>
                            <Input
                                name="id"
                                placeholder='Id...'
                                value={searchParams.id}
                                onChange={e => dispatch(setProductSearchParamsAction({ key: e.target.name, value: e.target.value }))}
                            />
                        </td>
                        <td className='px-2'>
                            <Input
                                name="name"
                                placeholder='Varyasyon adı...'
                                value={searchParams.code}
                                onChange={e => dispatch(setProductSearchParamsAction({ key: e.target.name, value: e.target.value }))}
                            />
                        </td>
                        <td className='px-2'>
                            <ColorPicker
                                pendingApiCall={pendingApiCallColor}
                                state={searchParams.color}
                                setState={(value) => dispatch(setProductSearchParamsAction({ key: "color", value }))}
                                query={colorQuery}
                                setQuery={setColorQuery}
                                page={colorPage}
                                onClickClear={() => dispatch(setProductSearchParamsAction({ key: "color", value: null }))}
                                onClickLoadMore={() => onClickLoadMoreColor()}
                            />
                        </td>
                        <td className='px-2'>
                            <WeightPicker
                                pendingApiCall={pendingApiCallWeight}
                                state={searchParams.weight}
                                setState={(value) => dispatch(setProductSearchParamsAction({ key: "weight", value }))}
                                query={weightQuery}
                                setQuery={setWeightQuery}
                                page={weightPage}
                                onClickClear={() => dispatch(setProductSearchParamsAction({ key: "weight", value: null }))}
                                onClickLoadMore={() => onClickLoadMoreWeight()}
                            />
                        </td>
                        <td className='px-2'>
                            <PatternPicker
                                pendingApiCall={pendingApiCallPattern}
                                state={searchParams.pattern}
                                setState={(value) => dispatch(setProductSearchParamsAction({ key: "pattern", value }))}
                                query={patternQuery}
                                setQuery={setPatternQuery}
                                page={patternPage}
                                onClickClear={() => dispatch(setProductSearchParamsAction({ key: "pattern", value: null }))}
                                onClickLoadMore={() => onClickLoadMorePattern()}
                            />
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    {
                        productPage.content.map((product, index) => (
                            <tr key={index} className='border-b items-center hover:bg-violet-100 duration-150'>
                                <td className='p-2'># {product.id} </td>
                                <td className='p-2'>{product.name} </td>
                                <td className='p-2'>{product.color ? `${product.color.name} ${product.color.code}` : "-"} </td>
                                <td className='p-2'>{product.weight ? `${product.weight.name} ${product.weight.code}` : "-"} </td>
                                <td className='p-2'>{product.pattern ? `${product.pattern.name} ${product.pattern.code}` : "-"} </td>
                                <td className='p-2'>{translateProductType(product.type)}</td>
                                <td className='p-2'>
                                    <div className='mb-1'>
                                        {Object.entries(product.stock).map(([location, quantity]) => (
                                            <p key={location}>
                                                {location}: {formatNumber(quantity)} m
                                            </p>
                                        ))}
                                        {/* <hr /> */}
                                    </div>
                                    <p className='font-semibold'>
                                        Toplam: {formatNumber(product.quantityOnHand)} m
                                    </p>

                                </td>
                                {/* <td className='p-2'>{product.averageCost}</td> */}
                                {/* <td className='p-2 gap-x-3'>
                                    <div className='flex items-center justify-center'>
                                        <span className='cursor-pointer hover:scale-125 hover:text-yellow-600 duration-150' onClick={() => nav(`/variation/${product.id}`)}>
                                            <FaEye />
                                        </span>
                                    </div>

                                </td> */}
                            </tr>
                        ))
                    }
                </tbody>
            </table>
            <LoadMore page={productPage} pending={pendingApiCall} onLoadMore={onLoadMore} />
        </div>
    )
}

export default VariationListPage